import { render, staticRenderFns } from "./ObjectAttribute.vue?vue&type=template&id=7ec87c50&scoped=true&"
import script from "./ObjectAttribute.vue?vue&type=script&lang=js&"
export * from "./ObjectAttribute.vue?vue&type=script&lang=js&"
import style0 from "./ObjectAttribute.vue?vue&type=style&index=0&id=7ec87c50&prod&scoped=true&lang=css&"
import style1 from "./ObjectAttribute.vue?vue&type=style&index=1&id=7ec87c50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec87c50",
  null
  
)

export default component.exports